import classnames from 'classnames'
import * as React from 'react'

import { PublicClassNames } from 'embed/constants'
import { DepositsFlow } from 'even-ts-static'

import ErrorIndicator from 'embed/components/ErrorIndicator'
import { configShouldUseCustomBackgroundSelector, isDeactivatedSelector } from 'embed/selectors/config'
import { connect } from 'react-redux'
import { uiMaxWidthForStep } from 'ui/multi-product/selectors/ui'

import AnchorInterceptor from '../AnchorInterceptor'
import Footer from '../Footer'
import { ProductPickerContainer } from '../ProductPicker/container'
import SelectedProduct from '../SelectedProduct/container'
import { useTheme } from 'embed/hooks'
import { DeactivatedEmbed } from '../DeactivatedEmbed'

const styles = require('./styles')

interface OwnProps {
  depositsFlow?: DepositsFlow
  plaidModalOpen: boolean
  viewportWidth?: number
}

interface StoreProps {
  enableCustomBackground: boolean
  isEmbedDeactivated: boolean
  maxWidth: string
}

type Props = OwnProps & StoreProps

const Render: React.FC<Props> = ({
  depositsFlow,
  enableCustomBackground,
  isEmbedDeactivated,
  maxWidth,
  plaidModalOpen,
  viewportWidth,
}) => {
  const { backdropStyles } = useTheme()
  const customStyles = enableCustomBackground
    ? { ...backdropStyles, margin: '0 auto', maxWidth, overflow: 'hidden' }
    : { overflow: 'hidden' }

  const containerClassName = depositsFlow === DepositsFlow.SavingsCalculator ? styles.savingsCalculator : undefined

  // If the plaid connect modal is displayed, set a class which establishes a min-height large enough
  // To accomidate the modal. This is required since the modal is fixed position is isn't considered
  // when setting the height of the widget.
  const plaidModalClass = plaidModalOpen ? styles.plaidModalMinHeightClass : null

  if (viewportWidth && viewportWidth < 260) {
    return <ErrorIndicator errorLabel="Sorry, your window is not wide enough to display the content." />
  }

  if (isEmbedDeactivated) {
    return <DeactivatedEmbed />
  }

  return (
    <AnchorInterceptor>
      <div className={classnames(PublicClassNames.Page, containerClassName, plaidModalClass)} style={customStyles}>
        <ProductPickerContainer />
        <SelectedProduct />
        <Footer />
      </div>
    </AnchorInterceptor>
  )
}
const mapStateToProps = (state) => ({
  enableCustomBackground: configShouldUseCustomBackgroundSelector(state),
  isEmbedDeactivated: isDeactivatedSelector(state),
  maxWidth: uiMaxWidthForStep(state),
})

export default connect(mapStateToProps)(Render)
